/* AUTO-GENERATED, DO NOT EDIT */
//Regions enabled
const enablePerformanceTestAPIRegion = false;
const enableDemoAPIRegion = true;
const enableBetaAPIRegion = false;
const enableLocalhostAPIRegion = false;

const CONFIG = {
  auth: {
    client_id: 'sstk-outlook-add-in-demo',
    client_secret: 'E3F1E332120B431794764C0AF30604A7',
  },
  graph: {
    client_id: '53b7914d-d345-454a-814a-06ba7f2bfb23',
  },
  urls: {
    form: 'https://demo-outlook.simplystakeholders.com/index.html',
    origin: 'https://demo-outlook.simplystakeholders.com/',
    graphLogin: 'https://demo-outlook.simplystakeholders.com/graph-login.html',
  },
  regions: [
    {
      label: 'Australia (au.simplystakeholders.com)',
      api_url: 'https://auapi.simplystakeholders.com',
      site_url: 'https://au.simplystakeholders.com',
    },
    {
      label: 'US (us.simplystakeholders.com)',
      api_url: 'https://usapi.simplystakeholders.com',
      site_url: 'https://us.simplystakeholders.com',
    },
    {
      label: 'EU (eu.simplystakeholders.com)',
      api_url: 'https://euapi.simplystakeholders.com',
      site_url: 'https://eu.simplystakeholders.com',
    },
    {
      label: 'Canada (ca.simplystakeholders.com)',
      api_url: 'https://ca-api.simplystakeholders.com',
      site_url: 'https://ca.simplystakeholders.com',
    },
  ],
  isComplaintsEnabled: false,
  isConfidentialOptionsEnabled: true,
  isAttachmentsEnabled: true,
  isNewSstkAutosaveContactEnabled: true,
  contactGroupName: 'SstkAutosave',
  appPrefix: 'sstk',
  appName: 'Simply Stakeholders',
  appIcon: '/assets/icon_60.png',
  appIconWidth: 264,
  appId: '03134ae1-d2c5-4d3f-9126-261c616ac673', // must be the same as in manifest
  freeTrialUrl: 'https://simplystakeholders.com/software-pricing/',
  privacyPolicyUrl: 'https://simplystakeholders.com/privacy-policy/',
  enableDemoAPIRegion: enableDemoAPIRegion,
  autosaveIntervalInMinutes: 15,
  allowToSaveMessageAgain: false,
  isGraphApiEnabled: true,
};

if (enablePerformanceTestAPIRegion) {
  CONFIG.regions.push({
    label: 'Performance Test (performance-test.simplystakeholders.com)',
    api_url: 'https://performance-test-api.simplystakeholders.com',
    site_url: 'https://beta.simplystakeholders.com',
  });
}

if (enableDemoAPIRegion) {
  CONFIG.regions.push({
    label: 'Demo (demo.simplystakeholders.com)',
    api_url: 'https://demo-api.simplystakeholders.com',
    site_url: 'https://demo.simplystakeholders.com',
  });
}

if (enableBetaAPIRegion) {
  CONFIG.regions.push({
    label: 'Beta (beta.simplystakeholders.com)',
    api_url: 'https://beta-api.simplystakeholders.com',
    site_url: 'https://beta.simplystakeholders.com',
  });
}

if (enableLocalhostAPIRegion) {
  CONFIG.regions.push({
    label: 'localhost (localhost:4200)',
    api_url: 'https://localhost:44334',
    site_url: 'https://localhost:4200',
  });
}

export default CONFIG;
